import { ArrowUp } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-royal-900 border-t border-beige/10 px-6 md:px-12 lg:px-24 py-16"
    >
      <div className="flex flex-col lg:flex-row justify-between gap-10">
        <div className="max-w-sm">
          <div className="mb-5 leading-[0.92]">
            <span className="block font-display text-2xl text-beige-light">Titanium</span>
            <span className="block font-display italic text-2xl text-gold-gradient">
              Wealth
            </span>
          </div>
          <p className="text-beige/60 leading-relaxed">
            Building a better future through strategic impact. Real estate,
            investment and development engineered for enduring value.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-10">
          <div>
            <p className="font-accent text-xs uppercase tracking-[0.24em] text-gold mb-4">
              Navigate
            </p>
            <ul className="space-y-3 text-beige/70">
              {["About", "Projects", "Partnerships", "Companies", "Contact"].map(
                (l) => (
                  <li key={l}>
                    <a
                      href={`#${l.toLowerCase()}`}
                      className="hover:text-gold transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
          <div>
            <p className="font-accent text-xs uppercase tracking-[0.24em] text-gold mb-4">
              Get In Touch
            </p>
            <p className="text-beige/70 leading-relaxed mb-4">
              Interested in a partnership? Send us a message and our team will
              respond personally.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 font-accent text-sm uppercase tracking-[0.18em] text-beige-light hover:text-gold transition-colors"
            >
              Send a Message →
            </a>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <a
              href="#top"
              data-testid="back-to-top"
              className="inline-flex items-center gap-2 font-accent text-sm uppercase tracking-[0.18em] text-beige/80 border border-beige/20 px-5 py-3 hover:border-gold hover:text-gold transition-colors"
            >
              Back to top <ArrowUp size={14} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-beige/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-beige/50">
        <p>© {new Date().getFullYear()} Titanium Wealth USA. All rights reserved.</p>
        <p className="font-accent uppercase tracking-[0.2em]">
          Strategic Impact · Global Vision
        </p>
      </div>
    </footer>
  );
};

export default Footer;
